import { Card, CardActionArea, CardContent, Typography, Chip, Stack, Box } from '@mui/material';

export default function CameraGallery({ cameras, selectedId, onSelect }) {
  return (
    <Stack direction="row" flexWrap="wrap" gap={2}>
      {cameras.map((cam) => (
        <Card
          key={cam.id}
          sx={{ width: 260, opacity: cam.enabled ? 1 : 0.5,
                outline: cam.id === selectedId ? '2px solid' : 'none' }}
        >
          <CardActionArea disabled={!cam.enabled} onClick={() => cam.enabled && onSelect(cam)}>
            <CardContent>
              <Typography variant="subtitle1">{cam.name}</Typography>
              {!cam.enabled && <Typography variant="caption" color="text.secondary">disabled</Typography>}
              <Box sx={{ mt: 1 }}>
                {cam.connectedSensors.length === 0 ? (
                  <Typography variant="caption" color="text.secondary">No sensors linked</Typography>
                ) : (
                  <Stack direction="row" flexWrap="wrap" gap={0.5}>
                    {cam.connectedSensors.map((s) => (
                      <Chip key={s.id} size="small" label={s.name} />
                    ))}
                  </Stack>
                )}
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </Stack>
  );
}
